module.exports = __webpack_public_path__ + "static/media/029-clipboard.88c4b8f9.svg";